import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import theme from "../../theme";
import styled from "@emotion/styled";

const { md } = theme.screen;

type Prop = {
  title: string;
  path: string;
};

export const SubCategory = ({ title, path }: Prop) => {
  return (
    <Box
      component={"li"}
      sx={{
        display: "flex",
        alignItems: "end",
      }}
    >
      <StyledLink to={path}>{title}</StyledLink>
    </Box>
  );
};

// styled component로 Link 스타일 정의
const StyledLink = styled(Link)({
  width: "240px",
  color: theme.color.neutral_700,
  fontSize: "20px",
  fontWeight: "500",
  lineHeight: "32px",
  padding: "8px 0px",
  borderBottom: "2px solid black",
  textDecoration: "none", // 기본 링크 스타일 제거
  transition: "200ms",

  "&:hover": {
    color: theme.color.green_500, // hover 시 색상 변경
    borderBottomColor: theme.color.green_500, // hover 시 색상 변경
  },

  [`@media (max-width: ${md}px)`]: {
    fontSize: "16px",
    width: "100%",
  },
});
